import { TariffFormModelDto } from '../api/dto/tariffs-form.dto'
import { AddTariffFormData } from '../components/add-tariff/AddTariffForm'

const STEP_SIZE_VALUE = 1

/**
 * Function for transforming tariffs from model to be form model
 * @param tariffs - TariffsFormData object
 * @param installationId - unique installation identifier as number
 * @returns object of TariffFormModelDto
 */
export const tariffsFormToDto = (data: AddTariffFormData, installationId: number): TariffFormModelDto => {
  return {
    installationId,
    tariffName: data.tariffName,
    dischargePrice: Number(data.tariffDischargePrice),
    tariffDto: {
      start_date_time: data.startDate && new Date(data.startDate).toISOString(),
      end_date_time: data.endDate && new Date(data.endDate).toISOString(),
      elements: [
        {
          price_components: [
            { price: Number(data.tariffGridPrice), type: 'ENERGY', step_size: STEP_SIZE_VALUE },
            { price: Number(data.tariffSolarPrice), type: 'FLAT', step_size: STEP_SIZE_VALUE },
          ],
        },
      ],
    },
  }
}
